window.VWFS = window.VWFS || {};
VWFS.ETrustedWidget = function () {

    this.init = function () {
        let widgets = document.querySelectorAll(".vwfs-dmp-etrusted-widget");

        if (widgets.length > 0) {

            widgets.forEach(widget => {
                let script = document.createElement('script');
                let type = widget.getAttribute("data-type");
                let id = widget.getAttribute("data-etrusted-id");
                if (type === 'badge_inline') {
                    script.src = "https://widgets.trustedshops.com/integration/integration.js";
                    script.type = "module";
                    script.setAttribute("data-integration-id", id);
                    document.body.appendChild(script);
                } else if (type === 'badge') {
                    script.src = "https://widgets.trustedshops.com/js/" + id + ".js";
                    script.async = true;
                    script.charset = "UTF-8";
                    script.setAttribute("data-desktop-y-offset", "-40");
                    script.setAttribute("data-mobile-y-offset", "4");
                    script.setAttribute("data-desktop-disable-reviews", "false");
                    script.setAttribute("data-desktop-enable-custom", "false");
                    script.setAttribute("data-desktop-position", "left");
                    script.setAttribute("data-desktop-custom-width", "156");
                    script.setAttribute("data-desktop-enable-fadeout", "false");
                    script.setAttribute("data-disable-mobile", "false");
                    script.setAttribute("data-disable-trustbadge", "false");
                    script.setAttribute("data-mobile-custom-width", "156");
                    script.setAttribute("data-mobile-disable-reviews", "false");
                    script.setAttribute("data-mobile-enable-custom", "false");
                    script.setAttribute("data-mobile-position", "left");
                    script.setAttribute("data-mobile-enable-topbar", "false");
                    script.setAttribute("data-mobile-enable-fadeout", "true");
                    script.setAttribute("data-color-scheme", "light");
                    document.body.appendChild(script);
                } else {
                    script.src = "https://integrations.etrusted.com/applications/widget.js/v2";
                    document.head.appendChild(script);
                }

            })

        }

    }

}

document.addEventListener("DOMContentLoaded", function (event){
    console.debug("INFO eTrusted/widget.js loaded.");

    new VWFS.ETrustedWidget().init();
})
